import Cookies from 'js-cookie';
import React from "react";
import Pool from '../UserPool';
import { useHistory } from 'react-router-dom';
import { AuthenticationDetails, CognitoUser, CognitoUserAttribute } from 'amazon-cognito-identity-js';
export default function Login() {
  const elementRef = React.useRef(null);
  const history = useHistory()
  const [username, setUsername] = React.useState(null)
  const [password, setPassword] = React.useState(null)
  const [alert, setAlert] = React.useState(false)
  const [alert2, setAlert2] = React.useState(false)
  const [alert3, setAlert3] = React.useState(false)
  const [msg, setMsg] = React.useState('Please enter password')
  const [msg1, setMsg1] = React.useState('Please enter username')
  const [msg2, setMsg2] = React.useState('Incorrect username or password')
  const [loading, setLoading] = React.useState(null)

  // const [cookies, setCookie] = React.useCookies(['deviceId']);

  // if (!cookies.deviceId) {
  //   // generate a new unique device ID
  //   const deviceId = Math.random().toString(36).substr(2, 9);
  //   setCookie('deviceId', deviceId);
  // }


  function handleRegister() {

    history.push('/register')
  }
  function handleForgotPassword() {
    history.push('/ForgotPassword')
  }
  const getSession = async () => {
    return await new Promise((resolve, reject) => {
      const user = Pool.getCurrentUser();
      if (user) {
        user.getSession((err, session) => {
          if (err) {
            reject();
          } else {
            const attributes = new Promise((resolve, reject) => {
              user.getUserAttributes((err, attributes) => {
                if (err) {
                  reject();
                } else {
                  const results = {};
                  for (let attribute of attributes) {
                    const { Name, Value } = attribute;
                    results[Name] = Value
                  }
                  resolve(results);
                }

              });
            });
            resolve({ user, ...session, ...attributes });
          }
        });
      } else {
        reject();
      }
    });
  };
  const authenticate = async (Username, Password) => {
    return await new Promise((resolve, reject) => {
      const user = new CognitoUser({ Username, Pool });
      const authDetails = new AuthenticationDetails({ Username, Password });
      Cookies.set('InfoHeader', "");
      Cookies.set('InfoDescription', "");
      Cookies.set('InfoClass', "info display");
      user.authenticateUser(authDetails, {
        onSuccess: (data) => {
          resolve(data);
          if (data["idToken"] != null) {
            if (data["idToken"]["payload"]["custom:plan"] == "" || data["idToken"]["payload"]["custom:plan"] == null) {
              Cookies.set('Image', "/assets/img/User.png")
            }
            else {
              Cookies.set('Image', data["idToken"]["payload"]["custom:plan"])
            }
          }
          else {
            Cookies.set('Image', "/assets/img/User.png");
          }
        },
        onFailure: (err) => {
          reject(err);
        },
        newPasswordRequired: (data) => {
          resolve(data);
        },
      });
    });

  };
  async function handleLogin(e) {
    e.preventDefault();
    setAlert2(false)
    setAlert(false)
    setAlert3(false)
    if ((username == "" && password == "") || (username == null && password == null) || (username == "" && password == null) || (username == null && password == "")) {
      setMsg1('Please enter username')
      setMsg('Please enter password')
      setAlert(true)
      setAlert2(true)
    }
    if (username == "" || username == null) {
      setAlert(true)
    }
    else setAlert(false)
    if (password == "" || password == null) {
      setMsg('Please enter password')
      setAlert2(true)
    }

    else {
      const currentDate = new Date().toLocaleDateString();
      //const res = await axios.get('https://geolocation-db.com/json/')

      const macAddress = navigator.userAgent;
      setLoading(true)
      authenticate(username, password)
        .then((data) => {
          console.log(data);
          if (data["idToken"] != null) {
            // if(data["idToken"]["payload"]["custom:DeviceKey"] != macAddress && data["idToken"]["payload"]["custom:DeviceKey"] !="" && data["idToken"]["payload"]["custom:DeviceKey"] !=null )
            // {
            //   setMsg2('You are using different device to login. Please conact admin to refresh device token.')
            //   setAlert3(true);
            //   setLoading(false);
            //   return;
            // }

            if (data["idToken"]["payload"]["cognito:groups"] == "" || data["idToken"]["payload"]["cognito:groups"] == null) {
              setMsg2('You do not have any access of group. Please conact admin.')
              setAlert3(true);
              setLoading(false);
              return;
            }
            else {
              if (username.toLowerCase() != "ryan" && username.toLowerCase() != "abdul") {
                getSession().then(({ user }) => {
                  const attributes = [
                    new CognitoUserAttribute({ Name: "custom:DeviceKey", Value: macAddress }),
                  ];
                  user.updateAttributes(attributes, (err, result) => {
                    if (err) console.error(err);
                    // console.log(result);
                    if (result == "SUCCESS") {
                    }
                  });
                });
              }
              setLoading(false);
              Cookies.set('Group', data["idToken"]["payload"]["cognito:groups"][0])
              Cookies.set('username', username)
              if (data["idToken"]["payload"]["custom:UsedClicks"] != null) { Cookies.set('UsedClicks', data["idToken"]["payload"]["custom:UsedClicks"]) }
              else { Cookies.set('UsedClicks', "0") }
              if (data["idToken"]["payload"]["custom:PerMonthClick"] != null) { Cookies.set('PerMonthClick', data["idToken"]["payload"]["custom:PerMonthClick"]) }
              else { Cookies.set('PerMonthClick', "0") }
              history.push('/')

            }
          }
          else {
            // Cookies.set('Group',"")
            // Cookies.set('username', username)
            // Cookies.set('UsedClicks', "0")
            // Cookies.set('PerMonthClick', "15")
            // history.push('/')
            setMsg2('Your profile has not be completed. Please contact admin.')
            setAlert3(true);
            setLoading(false);
            return;
          }
        })
        .catch((error) => {
          setMsg2(error.message)
          setAlert3(true);
          setLoading(false);
          console.log(error);
        });
    }


  }
  return (

    <section class="ftco-section">
      {/* <div className="modal-overlay hide-pc">
<div className="card" style={{marginTop:"50%"}}>
            <div className="card-body text-center" >
                <h3 className="card-title"><i className='fa fa-warning mr-2'></i><br></br>Alert !</h3>
                <p className="card-text">At this moment, the application is exclusively compatible with the
desktop mode. However, please rest assured that our team is diligently working towards
enhancing its compatibility with mobile interfaces. We understand the inconvenience
caused and greatly appreciate your patience and understanding during this process.<br></br>
Thank you.</p>
                
            </div>
        </div>
</div> */}

      <div class="content">

        <div class="header-area">
          <a href="#"><img src="assets/img/logo.png" alt="logo-singin.png"></img></a>
        </div>
        <div class="row wrap d-md-flex">
          <div class="col-md-8 login-wrap">
            <div class="inner_content">
              <div class="d-flex">
                <div class="w-100">
                  <h3 class="mb-0">Sign In</h3>
                </div>
              </div>
              <form onSubmit={handleLogin} class="signin-form">
                <h6>
                  {alert3 && (
                    <span style={{ color: 'red' }}>{msg2}</span>
                  )}</h6>
                <div class="form-group mb-0">
                  <label class="label" for="name">
                    User name{' '}
                    {alert && (
                      <span style={{ color: 'red' }}>{msg1}</span>
                    )}
                  </label>
                  <input type="text"
                    value={username}
                    class="form-control"
                    onChange={(e) => setUsername(e.target.value)} required />
                </div>

                <div class="form-group mb-0">
                  <label class="label" for="password">Password {' '}
                    {alert2 && <span style={{ color: 'red' }}>{msg}</span>}
                  </label>
                  <input type="password"
                    class="form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)} required />
                </div>
                <div class="forget_target text-md-right" onClick={handleForgotPassword}>
                  <a href="#">Forgot Password?</a>
                </div>
                <div class="form-group mb-0">
                  <a onClick={handleLogin}>
                    <button type="submit" class="btn btn-primary rounded submit submit_btn">
                      {loading && <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>}
                      Sign In</button></a>
                </div>

              </form>
              <p class="text-center register_content">Don’t have an account? <a onClick={handleRegister} data-toggle="tab" href="#signup">Register Now</a></p>
            </div>
          </div>

          <div class="col-md-4 city-dashboard1 img Landbrige_map" >
            <div class="bg_content">
              <img src="assets/img/LB-Icon-White.svg" alt="LB-Icon-White.svg"></img>
              <h2>land analysis made simple</h2>
            </div>
          </div>
        </div>

      </div>
    </section>
  )
}